import IconFinish from './component.jsx'
export default IconFinish
